import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import {  } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { de, el } from "date-fns/locale";
import { set } from "date-fns";

function StoreSearch(props) {
    const [productAll, setStoreAll] = useState(JSON.parse(localStorage.getItem("store")));
    const [filterItem, setFilterItem] = useState([]);
    const [id, setid] = useState(0);
    const [user, setuser] = useState(null);
    const [showTable, setShowTable] = useState(true);
    const [store, setStore] = useState(null);

    const handleSearchChange = (value) => {
        setShowTable(true);
        const filtered = productAll.filter(item =>
            item.description.toLowerCase().includes(value)
        );
        setFilterItem(filtered);
        if (filtered.length > 0) {
            ItemDiv(filtered);
        }
    }

    function handleAddToCart(Id) {
        setid(Id);
        setShowTable(false);
        const selected = productAll.find(product => product.id === Id);
        console.log("Selected Product:", selected);
        setuser(selected);
        props.onStoreelect && props.onStoreelect(selected);
    }

    function ItemDiv({ filterItem }) {
        if (!Array.isArray(filterItem) || filterItem.length === 0) {
            return '';
        }
        return (
            <div className="card">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th hidden></th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterItem.map((item, index) => (
                            <tr key={index} onClick={() => handleAddToCart(item.id)} style={{ cursor: "pointer" }}>
                                <th scope="row">{index + 1}</th>
                                <td hidden>{item.id}</td>
                                <td>{item.description || "—"}</td>
                                <td>{item.rate ?? "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                setShowTable(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    const handleInputChange = (id, value) => {
        const numericValue = parseInt(value, 10);
        setStore(prevItems =>
            prevItems.map(item =>
                item.id === id
                    ? { ...item, qty: isNaN(numericValue) ? 0 : numericValue, amount: item.price * numericValue }
                    : item
            )
        );
    };

    return (
        <div className="product-view">
            <div  style={{ position: "relative" }}>
                <div className="col-md-6"><h6>Cart product of </h6> <h4>{props.cname}</h4></div>
                {/* <div className="col-md-6"> */}
                    {/* <div className="row"> */}
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            // width: "100%",
                            zIndex: 100,
                            background: "white" // optional, but useful if you want to visually separate
                        }}>
                            <input type="text" placeholder="search product..." className="form-control" onChange={e => handleSearchChange(e.target.value)}></input>
                            {showTable && <ItemDiv filterItem={filterItem} />}
                            <input type="number" id="custId" name="custId" value={id} hidden onChange={e => setid(e.target.value)}></input>
                        </div>
                    {/* </div> */}
                {/* </div> */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StoreSearch);